import { Controller } from 'stimulus';
import { MeganavKeyboard } from '../helper-classes/meganav_keyboard_helper';

export default class extends Controller {
  static targets = [
    'userNav',
    'container',
    'icon',
    'column',
    'header',
    'meganav',
    'meganavMenu',
  ]

  connect() {
    const userNavExists = document.querySelector('.user-logged-in__drop-down');
    const userLoggedIn = document.querySelector('.user-logged-in')

    if (userNavExists) {
      document.addEventListener('keydown', (e) => {
        e.keyCode === 27 ? this.userNavTarget.setAttribute('data-user-nav-active', 'false') : null;
      });

      document.addEventListener('click', (e) => {
        if (!this.userNavTarget.contains(e.target)) {
          this.userNavTarget.setAttribute('data-user-nav-active', 'false');
        }
      });
      userLoggedIn.style.width = userLoggedIn.offsetHeight - 70 + userLoggedIn.offsetWidth + 'px'
    }

    this.meganavKeyboard = new MeganavKeyboard({
      getMeganavTargets: () => this.meganavTargets,
      getMeganavMenuTargets: () => this.meganavMenuTargets,
      hideMeganavs: () => this.hideMeganavs(),
      expandMeganav: (_anchor, _menuItem, meganav) => this.expandMeganav(meganav),
    });

    $('.page-wrapper').on('click', () => {
      this.hideMeganavs();
    });

    if (window.location.href.indexOf('programme') > -1) {
      $('.hero-wrapper').css('padding-top', '130px');
    }
  }

  toggleNav() {
    this.switchDataAttr(this.containerTarget);
    this.switchDataAttr(this.iconTarget);
    if (this.containerTarget.dataset.mobileMenuActive === 'true') {
      this.headerWasNormal = this.headerTarget.classList.contains('header--is-normal');
      this.headerTarget.classList.add('header--is-normal');
    } else {
      if (!this.headerWasNormal) {
        this.headerTarget.classList.remove('header--is-normal');
      }
      this.hideMeganavs();
    }
  }

  switchDataAttr(targetElement) {
    targetElement.getAttribute('data-mobile-menu-active') !== 'true'
      ? targetElement.setAttribute('data-mobile-menu-active', 'true')
      : targetElement.setAttribute('data-mobile-menu-active', 'false');
  }

  showUserNav(e) {
    e.stopPropagation();
    this.userNavTarget.getAttribute('data-user-nav-active') !== 'true'
      ? this.userNavTarget.setAttribute('data-user-nav-active', 'true')
      : this.userNavTarget.setAttribute('data-user-nav-active', 'false');
  }

  showColumn(column) {
    this.hideColumns();
    column.classList.add('active');
  }

  hideColumns() {
    for (let column of this.columnTargets) {
      column.classList.remove('active');
    }
  }

  toggleColumn({ currentTarget: { parentElement } }) {
    if (parentElement.classList.contains('active')) {
      this.hideColumns();
    } else {
      this.showColumn(parentElement);
    }
  }

  hideMeganavs() {
    for (let meganav of this.meganavTargets) {
      meganav.style.display = 'none';
    }
    for (let meganavMenu of this.meganavMenuTargets) {
      delete meganavMenu.dataset.active;
    }
    this.headerTarget.classList.remove('header--is-white');
    this.hideColumns();
    this.meganavKeyboard?.removeDropdownKeyboardHandlers();
  }

  toggleMeganav(event) {
    event.preventDefault();
    const anchor = event.currentTarget;
    const menuItem = anchor.closest('.meganav-menu');
    const meganavType = menuItem.dataset.meganav;
    const active = menuItem.dataset.active === 'true';

    if (active) {
      this.hideMeganavs();
      anchor.focus();
    } else {
      this.expandMeganav(meganavType);
    }
  }

  expandMeganav(meganavType) {
    for (let meganavElement of this.meganavTargets) {
      meganavElement.style.display = meganavElement.dataset.meganav === meganavType ? 'block' : 'none';
    }
    
    for (let meganavMenuItem of this.meganavMenuTargets) {
      if (meganavMenuItem.dataset.meganav === meganavType) {
        meganavMenuItem.dataset.active = 'true';
      } else {
        delete meganavMenuItem.dataset.active;
      }
    }
    
    this.headerTarget.classList.add('header--is-white');
    this.hideColumns();
    this.meganavKeyboard?.setupDropdownKeyboardNavigation(meganavType);
  }

  handleKeydown(event) {
    this.meganavKeyboard?.handleTriggerKeydown(event);
  }

  disconnect() {
    this.meganavKeyboard?.removeDropdownKeyboardHandlers();
    delete this.meganavKeyboard;
  }
}
